export default "/static/logo_monomer_full.svg";